import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const state = {
  generatedSpecialWorker: null,
  specialWorkers: []
};

const mutations = {
  SET_GENERATED_WORKER(state, worker) {
    state.generatedSpecialWorker = worker;
  },
  ADD_SPECIAL_WORKER(state, worker) {
    state.specialWorkers.push(worker);
  },
  REMOVE_SPECIAL_WORKER(state, workerId) {
    state.specialWorkers = state.specialWorkers.filter(w => w.id !== workerId);
  },
  SET_SPECIAL_WORKERS(state, workers) {
    state.specialWorkers = workers;
  }
};

const actions = {
  async generateSpecialWorker({ commit, dispatch }) {
    try {
      // O servidor usa só o usuário autenticado: nada de playerId no request
      const response = await api.get('/api/special-workers/generate', {
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      });
      
      // Log para debug
      console.log('API Response:', response.data);
      
      if (response.data?.data) {
        const worker = response.data.data;
        // Verificar se os dados estão corretos
        if (!worker.effectCoach || worker.effectCoach === 'none') {
          console.warn('Worker effect is none or missing:', worker);
        }
        commit('SET_GENERATED_WORKER', worker);
        // Atualizar dados do player após gerar worker
        await dispatch('player/loadPlayerData', null, { root: true });
        return worker;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error generating special worker:', error);
      throw new Error(error.response?.data?.error?.message || error.message);
    }
  },

  async hireSpecialWorker({ commit, dispatch }, worker) {
    try {
      const offerId = worker?.offerId;
      if (!offerId) {
        throw new Error('Oferta expirada, gere um novo treinador');
      }

      // O servidor usa a oferta guardada: preço, raridade e efeitos vêm de lá
      const response = await api.post('/api/special-workers', { offerId }, {
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      });
      
      if (response.data?.data) {
        // As moedas já foram debitadas no servidor: só recarrega o player
        await dispatch('player/loadPlayerData', null, { root: true });
        
        commit('ADD_SPECIAL_WORKER', response.data.data);
        commit('SET_GENERATED_WORKER', null);
        return response.data.data;
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error hiring special worker:', error);
      throw new Error(error.response?.data?.error?.message || error.message);
    }
  },

  async equipToGym(_, { workerId, gymId }) {
    try {
      // Fix: Send gymId directly in the request body, not inside a 'data' property
      const response = await api.post(`/api/special-workers/${workerId}/equip`, 
        { gymId }, // Fixed: Proper request body format
        {
          headers: { 
            Authorization: `Bearer ${Cookies.get('jwt')}`
          }
        }
      );
      
      if (!response.data?.data) throw new Error('Resposta inválida do servidor');
      return response.data.data;
    } catch (error) {
      console.error('Error equipping special worker:', error);
      throw error; // Just throw the original error
    }
  },

  async unequipFromGym(_, gymId) {
    try {
      const response = await api.post(`/api/special-workers/gym/${gymId}/unequip`, {}, { // Updated route
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      });
      
      if (!response.data?.data) throw new Error('Invalid response format');
      return response.data.data;
    } catch (error) {
      console.error('Error unequipping special worker:', error);
      throw new Error(error.response?.data?.error?.message || error.message);
    }
  },

  async fireSpecialWorker({ commit, dispatch }, workerId) {
    try {
      const response = await api.post(`/api/special-workers/${workerId}/fire`, {}, { // Updated route
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      });

      if (response.data?.data) {
        commit('REMOVE_SPECIAL_WORKER', workerId);
        // Refresh player data after firing
        await dispatch('player/loadPlayerData', null, { root: true });
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      console.error('Error firing special worker:', error);
      throw new Error(error.response?.data?.error?.message || error.message);
    }
  },

  async fetchPlayerSpecialWorkers({ commit }, playerId) {
    try {
      const response = await api.get(`/api/special-workers/player/${playerId}`, {
        headers: { 
          Authorization: `Bearer ${Cookies.get('jwt')}`
        }
      });
      
      if (response.data?.data) {
        commit('SET_SPECIAL_WORKERS', response.data.data);
        return response.data.data;
      }
      throw new Error('Invalid response format');
    } catch (error) {
      console.error('Error fetching special workers:', error);
      throw new Error(error.response?.data?.error?.message || error.message);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
